module.exports = __webpack_public_path__ + "static/media/ic-notification-bell.cdd40e4e.svg";